import React from 'react';
import PressPresenter from "./PressPresenter";
import { useParams, useNavigate } from 'react-router-dom';

import { useScrollTop, usePressList } from '../../hooks';

const PressContainer = () => {
  const navigate = useNavigate();
  const { page } = useParams();

  const currentPage = React.useMemo(() => {
    const pageNumber = parseInt(page, 10) || 1;
    return pageNumber > 0 ? pageNumber : 1;
  }, [page]);

  const { data } = usePressList(currentPage);

  const navigateToPressDetail = (id) => {
    navigate(`/press/detail/${id}`);
  };

  const onPageChange = (newPage) => {
    navigate(`/press/page/${newPage.selected + 1}`);
  };

  useScrollTop();

  return (
    <PressPresenter 
      press={data?.items || []} 
      count={data?.totalPages || 0} 
      currentPage={currentPage}
      onPageChange={onPageChange}
      navigateToPressDetail={navigateToPressDetail}
    />
  );
};

export default PressContainer;
